"use client";

import React, { Suspense } from "react";
import CustomLink, { CustomLinkProps } from "./CustomLink";

type ClientLinkProps = CustomLinkProps;

const ClientLink: React.FC<ClientLinkProps> = (props) => {
  return (
    <Suspense>
      <CustomLink {...props} />
    </Suspense>
  );
};

export default ClientLink;
